import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { YMInitializer } from 'react-yandex-metrika';

import Home from './routes/Home'
import Place from './routes/Place'
import Article from './routes/Article'
import Header from './components/header/header'
import { Provider } from 'react-redux'
import store from './store'
import { sendEvent } from "./helpers/analytics";

class App extends Component {
  componentDidMount () {
    window.onload = () => {
      sendEvent('main', 'load', 'main')
    }
  }
  render() {
    return (
      <div className="App">
        <YMInitializer accounts={[41145084]} />

        <Provider store={ store }>
          <Router>
            <div>
              <Header  />
              <Route
                render={({ location }) => (
                  <TransitionGroup>
                    <CSSTransition key={location.pathname} classNames="fade" timeout={1500} >
                      <Switch location={location}>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/place" component={Place} />
                        <Route exact path="/article/:id" component={Article} />
                      </Switch>
                    </CSSTransition>
                  </TransitionGroup>
              )} />
            </div>
          </Router>
        </Provider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js